import React from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { getRequiredPermission, getProjectIdFromPath } from "../../config/routePermissions";
import {
  getToken,
  hasPermission,
  hasProjectAccess,
  isSuperAdminUser,
} from "../../utils/auth";

/**
 * Guards business routes using permission flags from waSession.
 * Superadmin → Full Access; admin → Admin Access (registration.js).
 */
const PermissionGate = () => {
  const location = useLocation();
  const params = useParams();
  const projectId = params.projectId || getProjectIdFromPath(location.pathname);
  const token = getToken();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Superadmin: any project. Admin: only mapped projects. Agents: permissions + mapping.
  if (projectId && !hasProjectAccess(projectId)) {
    return <Navigate to="/unauthorized" replace />;
  }

  const required = getRequiredPermission(location.pathname);
  if (required === undefined) {
    return isSuperAdminUser() ? <Outlet /> : <Navigate to="/unauthorized" replace />;
  }

  if (required === null || hasPermission(required, undefined, projectId)) {
    return <Outlet />;
  }

  return <Navigate to="/unauthorized" replace />;
};

export default PermissionGate;
